import { render, staticRenderFns } from "./PolicyLayout.vue?vue&type=template&id=c815c96c&scoped=true"
import script from "./PolicyLayout.vue?vue&type=script&lang=js"
export * from "./PolicyLayout.vue?vue&type=script&lang=js"
import style0 from "./PolicyLayout.vue?vue&type=style&index=0&id=c815c96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c815c96c",
  null
  
)

export default component.exports